export const debug = false;
